import { getAxiosCounted } from 'pages/api/axios'
import { formatBaseLibraryURL } from 'utils/search/formateCountQuery'
import { IOptions } from 'constants/types/common.types'
import { CARDS_ON_PAGE } from 'constants/search-data/search-data'
import { Key, LibraryURL, Option } from 'constants/search-data/library-search-data'
import { IgetCardsMaterials } from 'constants/types/search.types'

const getCardsMaterials: IgetCardsMaterials = async (
  params,
  isReset,
  usedCardsCount,
  selectedOption
) => {
  const commonQuery = formatBaseLibraryURL(
    params[Key.TEXT] as string,
    params[Key.DATES] as Date[],
    params[Key.LECTURS] as IOptions[],
    params[Key.THEMES] as IOptions[],
    params[Key.SPECIALITIES] as IOptions[]
  )

  const limit = CARDS_ON_PAGE

  const offset = isReset ? 0 : (usedCardsCount - 1) * limit

  let finalURL
  if (selectedOption === Option.article) {
    finalURL = `${LibraryURL.ARTICLES}&limit=${limit}&offset=${offset}${commonQuery}`
  } else if (selectedOption === Option.video) {
    finalURL = `${LibraryURL.VIDEO}&limit=${limit}&offset=${offset}${commonQuery}`
  } else if (selectedOption === Option.clinic) {
    finalURL = `${LibraryURL.CLINIC}&limit=${limit}&offset=${offset}${commonQuery}`
  } else if (selectedOption === Option.podcast) {
    finalURL = `${LibraryURL.PODCAST}&limit=${limit}&offset=${offset}`
  } else if (selectedOption === Option.interactive) {
    finalURL = `${LibraryURL.INTERACTIVE}&limit=${limit}&offset=${offset}`
  } else {
    // Вообще сюда не должен заходить ни при каких условиях
    finalURL = `${LibraryURL.ARTICLES}&limit=${limit}&offset=${offset}${commonQuery}`
  }

  const allItems = await getAxiosCounted(finalURL)

  return {
    totalPages: Math.ceil(allItems.count / limit),
    allItems: allItems.rows,
    allCount: allItems.count,
  }
}

export { getCardsMaterials }
